export enum DialogMode {
    AddToCart = "CART",
    Edit = "Edit"
}

